import React from 'react';
import { NavBar } from '..';
import { StyleSheet, css } from 'aphrodite';

interface HeaderProps {
    pluginVersion: string;
    source: string;
    showMenu: boolean;
    disabled: boolean;
    notify: boolean;
    mode?: string;
}

export const Header: React.SFC<HeaderProps> = (props) => {
    const { pluginVersion, source, disabled, notify, showMenu, mode } = props;
    const navBarProps = { pluginVersion, source, disabled, notify, mode };

    return (
        <header className={css(styles.header)}>
            <div  className={css(styles.logo)}/>
            {showMenu && <NavBar {...navBarProps}/>}
        </header>
    );
};

const styles = StyleSheet.create({
    logo: {
        width: '170px',
        height: '42px',
        objectFit: 'contain',
        background: 'url(//cdn.trustpilot.net/brand-assets/1.1.0/logo-black.svg) no-repeat center',
        marginBottom: '29px'
    },
    header: {
        marginBottom: '37px'
    },
});



// WEBPACK FOOTER //
// ./src/CommonUI/UI/Header.tsx